import { PromptActionTypes } from "./prompt.types";

const INITIAL_STATE = {
  showPrompt: false,
  type: "",
  title: "",
  message: "",
  onConfirm: () => {},
  onCancel: () => {},
  intent: "default",
  confirmLabel: "",
  cancelLabel: "",
};

const promptReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PromptActionTypes.TOGGLE_PROMPT:
      return {
        ...state,
        // Derived from `type` rather than flipping the previous value: a
        // dialog can be dismissed by button, Escape, or an outside click, and
        // flipping meant two of those in one interaction re-opened an empty
        // prompt. Opening always passes "prompt"/"alert", closing passes "".
        showPrompt: Boolean(action.payload.type),
        type: action.payload.type,
        title: action.payload.title,
        message: action.payload.message,
        onConfirm: action.payload.onConfirm,
        onCancel: action.payload.onCancel,
        intent: action.payload.intent || "default",
        confirmLabel: action.payload.confirmLabel || "",
        cancelLabel: action.payload.cancelLabel || "",
      };

    default:
      return state;
  }
};

export default promptReducer;
